import React, { useState } from "react";
import { FaFileUpload, FaCamera } from "react-icons/fa";
import BaseModalAnimated from "../../components/modal/BaseModalAnimated";
import FileInput from "../../components/form/FileInput";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomInput from "../../components/form/CustomInput";
import CustomButton from "../../components/form/CustomButton";
import { showFormErrors } from "../../helpers/showFormErrors";
import CameraPhotoModal from "../../components/modal/CameraPhotoModal";
import { stopsResource } from "../../helpers/configRoutes/backend_helper";

const AddEvidenceModal = ({ modal, setModal, reload, setReload }) => {
  const [modalCamera, setModalCamera] = useState({ show: false });
  const [loading, setLoading] = useState(false);

  const validationDocument = useFormik({
    initialValues: {
      description: "",
      document: "",
      document_name: "",
      evidence: true,
    },
    validationSchema: Yup.object({
      document: Yup.string().required("Document is required"),
      description: Yup.string().required("Description is required"),
    }),
    onSubmit: async (values, { setErrors, resetForm }) => {
      setLoading(true);
      const response = await stopsResource("put", values, modal.id);
      if (response.status) {
        setLoading(false);
        setReload(!reload)
        setModal({ ...modal, show: false });
      }
      setLoading(false);
    },
  });

  return (
    <>
      <BaseModalAnimated modal={modal} setModal={setModal}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            validationDocument.handleSubmit();
            showFormErrors(validationDocument);
            return false;
          }}
          className="p-6 space-y-6"
        >
          <div className="flex flex-col sm:flex-row gap-4 items-center">
            <div className="w-full">
              <FileInput
                validation={validationDocument}
                format={"all"}
                name={"document"}
                nameInput={"Evidence"}
              />
            </div>
            <CustomButton
              type={"button"}
              onClick={() => setModalCamera({ show: true, inputName: "document" })}
              className="flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded-full shadow-lg hover:bg-blue-600 transition"
            >
              <FaCamera className="text-lg" />
              Take Photo
            </CustomButton>
          </div>

          <p className="text-gray-500 flex items-center gap-2">
            <FaFileUpload className="text-blue-500" />
            Evidence: {validationDocument.values.document_name || "No file uploaded"}
          </p>

          <CustomInput
            label="Description"
            type="text"
            name="description"
            labelClassName="text-[14px] text-[#ADADAD] whitespace-nowrap"
            error={validationDocument?.errors?.description}
            value={validationDocument?.values?.description}
            handleChange={validationDocument.handleChange}
          />

          <div className="flex justify-center">
            <CustomButton
              type={"submit"}
              loading={loading}
              textLoad={"Saving..."}
              className="w-full sm:w-auto bg-green-500 text-white rounded-lg px-6 py-3 font-semibold shadow-md hover:bg-green-600 transition-all"
            >
              {loading ? (
                <span className="flex items-center gap-2">
                  <svg
                    className="animate-spin h-5 w-5 text-white"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v8H4z"
                    ></path>
                  </svg>
                  Guardando
                </span>
              ) : (
                "Add Evidence"
              )}
            </CustomButton>
          </div>
        </form>


      </BaseModalAnimated>
      {modalCamera.show && (
        <CameraPhotoModal
          confirm={true}
          modal={modalCamera}
          setModal={setModalCamera}
          validation={validationDocument}
        />
      )}
    </>
  );
};

export default AddEvidenceModal;
